module.exports = __webpack_public_path__ + "media/images/sns02-1da5e34ba59c134cf4bf1e112081d83c.png";